import { h } from '@stencil/core';

// State for selected options (would be local component state in a real component)
let selectedOptionIds: string[] = [];
let selectedOption: string[] = [];
let isSubmitting: boolean = false;

export function renderQuizModal(component: any, onAnswer: (optionIds: string[]) => Promise<boolean | void>, onClose: () => void) {
  if (!component.currentQuiz) return null;

  const answeredQuiz = component.quizAnswered.find(q => q.quizQuestion.id === component.currentQuiz.id);
  const hasAnswered = !!answeredQuiz;
  const isMultiSelect = component.currentQuiz.questionType === 'multi_select';
  const options = component.currentQuiz?.quizOptions;
  const position = component.currentQuiz?.position ?? 'center';
  const contentAlignment = position === 'top-left' ? 'start' : position === 'top-right' ? 'end' : 'center';

  const handleOptionSelect = (option: string, optionId: string) => {
    if (isMultiSelect) {
      const optionIndex = selectedOptionIds.indexOf(optionId);
      if (optionIndex === -1) {
        selectedOptionIds.push(optionId);
        selectedOption.push(option);
      } else {
        selectedOptionIds.splice(optionIndex, 1);
        selectedOption.splice(optionIndex, 1);
      }
    } else {
      selectedOptionIds = [optionId];
      selectedOption = [option];
      // For single select, submit immediately if not multi-select
      if (!isMultiSelect) {
        submitAnswer();
      }
    }
  };

  const submitAnswer = async () => {
    if (selectedOptionIds.length > 0) {
      isSubmitting = true;
      component.isLoading = true;
      await onAnswer(selectedOptionIds);
      component.isLoading = false;
      isSubmitting = false;
      setTimeout(() => {
        closeModal();
      }, 3000);
    }
  };

  const closeModal = () => {
    selectedOptionIds = [];
    selectedOption = [];
    isSubmitting = false;
    onClose();
  };

  function hexToRgb(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b},0.55)`;
  }
  const modalBg = getComputedStyle(document.documentElement).getPropertyValue('--vp-primary-bg').trim();
  const optionBg = getComputedStyle(document.documentElement).getPropertyValue('--vp-controls-bg').trim();

  return (
    <div class="quiz-overlay" style={{ justifyContent: contentAlignment }}>
      <div class="quiz-modal" style={{ background: hexToRgb(modalBg) }}>
        <div class="quiz-header">
          <h3>Quiz Question</h3>
          <button class="close-btn" onClick={closeModal}>
            ×
          </button>
        </div>
        <div class="quiz-content">
          <p class="quiz-question">{component.currentQuiz.question}</p>
          <div class="quiz-options">
            {options.map(option => {
              const isSelected = hasAnswered ? answeredQuiz.answer.includes(option.id) : selectedOptionIds.includes(option.id);
              const isCorrect = component.currentQuiz.answer.includes(option.option);

              return (
                <button
                  key={option.id}
                  class={`quiz-option-full ${hasAnswered ? 'voted' : ''} ${
                    isSelected ? (hasAnswered ? (isCorrect ? 'correct-opt' : 'incorrect-opt') : 'selected') : hasAnswered && isCorrect ? 'correct-opt' : ''
                  }`}
                  style={hasAnswered ? {} : { background: optionBg }}
                  onClick={() => !hasAnswered && handleOptionSelect(option.option, option.id)}
                  disabled={hasAnswered}
                >
                  <span>{option.option}</span>
                  {hasAnswered && isSelected && <span style={{ marginLeft: 'auto' }}>{isCorrect ? '✔' : 'X'}</span>}
                </button>
              );
            })}
          </div>

          {!hasAnswered && isMultiSelect ? (
            !isSubmitting ? (
              <button class="submit-btn" onClick={submitAnswer} disabled={selectedOptionIds.length === 0}>
                Submit
              </button>
            ) : (
              <button class="submit-btn">Submitting...</button>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
}
